
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitonashikcab() {



    const cardData =
    {
        keyword: 'Mumbai to Nashik Cab',
        heading: 'S9 Travels: Mumbai to Nashik Cab',
        headingDescription: 'S9 Travels offers safe, affordable, and comfortable Mumbai to Nashik cab services, perfect for business travelers, families, and devotees heading to the holy Trimbakeshwar Temple. The distance between Mumbai and Nashik is around 165 kilometers, usually covered in 3.5 to 4 hours via the scenic Mumbai–Nashik Expressway. Our fleet includes AC sedans, SUVs, and premium Innova Crysta cabs, all driven by experienced and courteous chauffeurs who ensure a smooth and enjoyable journey. Whether you need a one-way drop, round trip, or corporate travel package, S9 Travels provides clean cars, on-time pickup, and 24×7 booking assistance. With transparent fares and well-maintained vehicles, we make your Mumbai to Nashik cab ride convenient, safe, and stress-free — the perfect blend of reliability, comfort, and value.',


        top: 'Top Places to Visit in Nashik with S9 Travels',

"topPlaces": [
    {
      "title": "Trimbakeshwar Temple",
      "description": "One of the most sacred Jyotirlingas in India, Trimbakeshwar Temple is dedicated to Lord Shiva. Located about 28 km from Nashik, this temple is known for its unique Shiva Lingam, which represents the trinity of Brahma, Vishnu, and Mahesh. Pilgrims visit this temple for religious rituals, including the famous Narayan Nagbali Puja. The temple is surrounded by the picturesque Brahmagiri Hills, adding to its divine aura."
    },
    {
      "title": "Sula Vineyards",
      "description": "Nashik is known as India’s wine capital, and Sula Vineyards is its most famous winery. Visitors can take a guided tour of the vineyard, enjoy wine-tasting sessions, and relax in the scenic surroundings. The vineyard also hosts the annual SulaFest, a vibrant music and wine festival. The on-site restaurants offer a perfect setting for a leisurely meal with a glass of Sula’s finest wines."
    },
    {
      "title": "Panchavati",
      "description": "A place of immense mythological significance, Panchavati is believed to be where Lord Rama, Sita, and Lakshmana stayed during their exile. Key attractions here include the sacred Sita Gufa (cave where Sita was said to have hidden from Ravana), Kalaram Temple, and Ramkund, a holy bathing ghat on the Godavari River where devotees perform rituals for their ancestors."
    },
    {
      "title": "Anjaneri Hills",
      "description": "Believed to be the birthplace of Lord Hanuman, Anjaneri Hills is a popular trekking destination near Nashik. The trek takes you through scenic landscapes, caves, and waterfalls, culminating in a temple dedicated to Anjani Mata, Hanuman’s mother. The hill offers breathtaking views of the surrounding valleys and is a paradise for adventure seekers and spiritual travelers alike."
    },
    {
      "title": "Someshwar Waterfalls",
      "description": "A picturesque waterfall on the Godavari River, Someshwar Waterfalls (also called Dudhsagar Waterfalls) is a perfect getaway from the city's hustle and bustle. Located near the Someshwar Temple, the area is known for its lush greenery and refreshing ambiance. It’s an ideal picnic spot, especially during the monsoon when the waterfall is in full flow."
    },
    {
      "title": "Pandav Leni Caves",
      "description": "Dating back to the 2nd century BCE, the Pandav Leni Caves are a group of 24 Buddhist rock-cut caves carved into the Trirashmi Hills. These caves feature intricate carvings, Buddhist stupas, and viharas (monastic quarters). The trek up to the caves rewards visitors with panoramic views of Nashik city, making it a great spot for both history lovers and adventure enthusiasts."
    },
    {
      "title": "Muktidham Temple",
      "description": "A unique marble temple complex, Muktidham Temple houses replicas of the 12 Jyotirlingas found across India. Built in 1971, it features beautiful inscriptions from the Bhagavad Gita and sculptures of Hindu deities. The temple attracts devotees who wish to seek blessings and experience the spiritual ambiance of this sacred place."
    },
    {
      "title": "Saptashrungi Devi Temple",
      "description": "Located about 60 km from Nashik, Saptashrungi Devi Temple is a revered pilgrimage site dedicated to Goddess Saptashrungi. The temple is situated on a mountain range with 500 steps leading to the shrine. Surrounded by lush forests, the temple offers a tranquil atmosphere, making it a must-visit for devotees and nature lovers alike."
    },
    {
      "title": "Kalaram Temple",
      "description": "One of the oldest and most significant temples in Nashik, the Kalaram Temple is dedicated to Lord Rama. The temple's black stone idol of Rama, along with idols of Sita and Lakshmana, is highly revered. Built in the 18th century, the temple features stunning architectural designs and is an important landmark in the city's religious landscape."
    },
    {
      "title": "Ramkund",
      "description": "A sacred bathing ghat on the banks of the Godavari River, Ramkund is believed to be the spot where Lord Rama bathed during his exile. Devotees visit this holy place to perform religious rituals, especially Pind Daan (offering for ancestors). The Kumbh Mela, held every 12 years, sees millions of pilgrims taking a holy dip in Ramkund’s waters."
    }
],

"services": [
  {
    "name": "Mumbai to Nashik Cab Service",
    "description": "Book a trusted Mumbai to Nashik cab service with S9 Travels for a safe, smooth, and timely journey. Our fleet includes clean AC vehicles and expert drivers to ensure your trip is stress-free and comfortable."
  },
  {
    "name": "Book Mumbai to Nashik Taxi",
    "description": "Planning a trip to Nashik? Book your Mumbai to Nashik taxi online with S9 Travels and enjoy flexible booking, instant confirmation, and door-to-door pickup for a seamless travel experience."
  },
  {
    "name": "Affordable Mumbai to Nashik Cab",
    "description": "Looking for an affordable Mumbai to Nashik cab? S9 Travels offers budget-friendly fares without compromising on quality, safety, or comfort, making us the ideal choice for cost-conscious travelers."
  },
  {
    "name": "Private Taxi for Nashik from Mumbai",
    "description": "Enjoy a personalized ride with our private taxi service from Mumbai to Nashik. Ideal for business travelers, families, or couples seeking privacy, comfort, and flexibility on their journey."
  },
  {
    "name": "Mumbai to Nashik One-Way or Round Trip",
    "description": "Whether you need a one-way drop or a round-trip taxi from Mumbai to Nashik, S9 Travels provides customized travel solutions with transparent pricing and convenient scheduling."
  },
  {
    "name": "Luxury Cab from Mumbai to Nashik",
    "description": "Upgrade your travel experience with our luxury cab service from Mumbai to Nashik. Ride in premium vehicles like Innova Crysta or sedans with leather interiors and enjoy superior comfort and style."
  },
  {
    "name": "Comfortable Taxi Ride for Nashik",
    "description": "Experience a smooth and relaxing Mumbai to Nashik taxi ride with S9 Travels. Our well-maintained cars and skilled drivers ensure your comfort throughout the scenic journey."
  },
  {
    "name": "Nashik Sightseeing by Taxi from Mumbai",
    "description": "Explore Nashik's best attractions with our sightseeing taxi from Mumbai. Visit Trimbakeshwar Temple, Sula Vineyards, Panchavati, and more with flexible stops and expert local drivers."
  },
  {
    "name": "Group Travel to Nashik from Mumbai",
    "description": "Traveling in a group? S9 Travels offers spacious cabs and tempo travellers for group travel from Mumbai to Nashik. Enjoy comfortable seating and ample luggage space for a relaxed group trip."
  }
],

"tableData": [
  ["Mumbai to Nashik Cab Service", "Book Mumbai to Nashik Taxi"],
  ["Affordable Mumbai to Nashik Cab", "Private Taxi for Nashik from Mumbai"],
  ["Mumbai to Nashik One-Way or Round Trip", "Luxury Cab from Mumbai to Nashik"],
  ["Comfortable Taxi Ride for Nashik", "Nashik Sightseeing by Taxi from Mumbai"],
  ["Group Travel to Nashik from Mumbai", ""],
  ["", ""]
],






"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Scenic Travel",
    "WhyChoosedescription": "S9 Travels offers a comfortable Mumbai to Nashik cab service, ideal for both business and leisure trips. Our well-maintained fleet of vehicles, including the Toyota Innova, ensures a smooth and enjoyable ride with ample space, air conditioning, and plush seating, allowing you to relax while traveling through scenic routes."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand the importance of time when traveling. Our Mumbai to Nashik cab service guarantees punctual pick-ups and drop-offs, ensuring that you reach your destination on time without any delays. Whether it’s for business, a religious visit, or a family trip, we offer reliable service every time."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are well-versed with the best routes to Nashik, ensuring a smooth, efficient, and safe journey. They prioritize your comfort and safety, providing a relaxing and pleasant ride throughout the trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for Mumbai to Nashik cab services. Our transparent pricing structure ensures no hidden charges, and you will receive a detailed breakdown of the cost during the booking process, allowing you to plan your travel budget accordingly."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Nashik Journey",
    "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features like GPS tracking, airbags, and seat belts, ensuring a safe and comfortable journey from Mumbai to Nashik for you and your passengers."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Mumbai to Nashik trip. Whether you need an early morning departure or a late-night return, we’re available to provide reliable service that fits your travel needs."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Nashik Trip",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you need to make stops along the way, have specific locations to visit, or require special arrangements, we offer customizable itineraries to make your Mumbai to Nashik journey more enjoyable and suited to your preferences."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Mumbai to Nashik cab with S9 Travels is simple and hassle-free. You can book your ride online through our website or mobile app, or contact our customer service team for personalized assistance, ensuring a smooth and quick booking experience."
  }
]













    }

    const faqData = [
        [
          {
            question: 'How can I book a cab from Mumbai to Nashik?',
            answer: 'Booking a cab from Mumbai to Nashik is easy! You can book your ride via our website, mobile app, or by contacting our customer service team. We ensure a comfortable and smooth journey to Nashik.',
          },
          {
            question: 'What types of vehicles are available for the Mumbai to Nashik trip?',
            answer: 'We offer a variety of vehicles for the Mumbai to Nashik trip, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the vehicle that best fits your group size and travel preferences.',
          },
          {
            question: 'How long does it take to travel from Mumbai to Nashik?',
            answer: 'The journey from Mumbai to Nashik typically takes about 3 to 4 hours, depending on traffic and road conditions. We ensure a timely and comfortable trip with regular updates from our drivers.',
          },
          {
            question: 'Is there a fixed fare for the Mumbai to Nashik cab service?',
            answer: 'The fare for the Mumbai to Nashik cab service depends on the type of vehicle, distance, and any additional services requested. Contact us for a customized quote, and we will provide you with transparent pricing based on your trip details.',
          },
          {
            question: 'Can I book a round-trip cab from Mumbai to Nashik?',
            answer: 'Yes, you can book a round-trip cab for your Mumbai to Nashik journey. Simply provide us with your return details, and we will ensure a smooth and timely return journey from Nashik to Mumbai.',
          },
          {
            question: 'Do you offer pick-up services from Mumbai for the Nashik trip?',
            answer: 'Yes, we provide pick-up services from anywhere in Mumbai, including hotels, homes, or specific locations for your trip to Nashik. Our drivers will ensure a comfortable start to your journey.',
          },
          {
            question: 'Are the drivers experienced for the Mumbai to Nashik trip?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes from Mumbai to Nashik. They ensure a safe, smooth, and enjoyable trip to Nashik, following all safety protocols.',
          },
          {
            question: 'Can I request additional stops during the Mumbai to Nashik journey?',
            answer: 'Yes, you can request additional stops for sightseeing, meals, or breaks during your Mumbai to Nashik journey. Simply inform us during the booking process, and we’ll customize the itinerary as per your preferences.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai to Nashik cab service?',
            answer: 'S9 Travels offers reliable, comfortable, and safe cab services for the Mumbai to Nashik trip. With experienced drivers, well-maintained vehicles, and exceptional customer service, we ensure you have a pleasant and memorable journey to Nashik.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Mumbai to Nashik with S9 Travels, and the experience was fantastic. The vehicle was clean and comfortable, and the driver was professional and friendly. The trip was smooth, and we enjoyed the scenic views along the way. Highly recommend S9 Travels for anyone traveling to Nashik!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip from Mumbai to Nashik with S9 Travels was excellent. The cab was spacious, and the driver was knowledgeable about the route. We had a comfortable and enjoyable ride. We’ll definitely book with S9 Travels again for our future trips.”',
        },
      ];
      
      
      
      
      
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Mumbai to Nashik Cab Service – S9 Travels",
    "image": "https://s9travels.com/images/keyword/mumbai-to-nashik-cab.jpg",
    "description":
      "Book Mumbai to Nashik cab with S9 Travels from ₹2299 (approx). Choose AC Hatchback, Sedan, SUV & Innova Crysta for one-way or round trip. Safe, comfortable travel via NH160 or express route with professional drivers, 24/7 support, and instant booking.",
    "brand": { "@type": "Brand", "name": "S9 Travels" },
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.9",
      "ratingCount": "10000"
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "2299",
      "availability": "https://schema.org/InStock",
      "url": "https://s9travels.com/mumbai-to-nashik-cab"
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is the fare for Mumbai to Nashik cab?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Mumbai to Nashik cab fare with S9 Travels typically starts from ₹2299 for AC Hatchback. Rates vary based on car type, route chosen, and any extra stops."
        }
      },
      {
        "@type": "Question",
        "name": "How long does it take to go from Mumbai to Nashik?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "The cab journey from Mumbai to Nashik takes about 3.5 to 4 hours via NH160 or express highway, but may vary based on traffic conditions."
        }
      },
      {
        "@type": "Question",
        "name": "Can I book one-way or round trip Mumbai to Nashik cab?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "Yes. S9 Travels offers both one-way and round-trip taxi services between Mumbai and Nashik with flexible pickup/drop options."
        }
      },
      {
        "@type": "Question",
        "name": "Which route is best from Mumbai to Nashik by cab?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text":
            "The most used route is via NH160 passing through Igatpuri. The Mumbai–Nashik Expressway (Kasara–Igatpuri stretch) also reduces travel time significantly."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "S9 Travels",
    "image": "https://s9travels.com/images/logo.png",
    "url": "https://s9travels.com/",
    "telephone": "+91 7090759555",
    "priceRange": "₹₹",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Wakad Road, Pimpri-Chinchwad",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "postalCode": "411057",
      "addressCountry": "IN"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "ratingCount": "10000"
    },
    "openingHours": "Mo-Su 00:00-23:59",
    "areaServed":
      "Mumbai, Nashik, Thane, Igatpuri, Kalyan, Dombivli, Vasai, Navi Mumbai"
  };


 



      
      
      


    return (
        <div>
         
   <Helmet>
      {/* Title */}
      <title>
        Mumbai to Nashik Cab from ₹2299 | One-Way & Round Trip Taxi – S9 Travels
      </title>

      {/* Meta Description */}
      <meta
        name="description"
        content="Book AC cab from Mumbai to Nashik starting at ₹2299 with S9 Travels. Travel comfortably via NH160 / Express route in Hatchback, Sedan, SUV & Innova Crysta. 24/7 customer support, professional drivers, instant online booking."
      />

      {/* Meta Keywords */}
      <meta
        name="keywords"
        content="Mumbai to Nashik Cab, Mumbai to Nashik Taxi, One Way Cab Mumbai Nashik, Round Trip Mumbai Nashik, AC Cab Mumbai Nashik, Innova Cab Mumbai Nashik, Cab Booking Mumbai to Nashik"
      />

      {/* Canonical */}
      <link rel="canonical" href="https://s9travels.com/mumbai-to-nashik-cab" />

      {/* Structured Data */}
      <script type="application/ld+json">{JSON.stringify(productSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>

      {/* Open Graph / Social Tags */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Mumbai to Nashik Cab from ₹2299 | S9 Travels"
      />
      <meta
        property="og:description"
        content="Travel from Mumbai to Nashik in AC comfort. Book hatchback, sedan, SUV & Innova with S9 Travels starting ₹2299. One-way & round-trip services available."
      />
      <meta
        property="og:image"
        content="https://s9travels.com/images/keyword/mumbai-to-nashik-cab.jpg"
      />
      <meta property="og:url" content="https://s9travels.com/mumbai-to-nashik-cab" />
      <meta property="og:site_name" content="S9 Travels" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Mumbai to Nashik Cab from ₹2299 | S9 Travels"
      />
      <meta
        name="twitter:description"
        content="Book Mumbai to Nashik AC cab service from ₹2299. Safe and comfortable travel via NH160/express route. One-way & round trip options."
      />
      <meta
        name="twitter:image"
        content="https://s9travels.com/images/keyword/mumbai-to-nashik-cab.jpg"
      />
    </Helmet>
         
      

      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/83.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitonashikcab;